import React from 'react';

import { ISelectedLocationProps } from '@/modules/periodicJobs/components/SelectedLoactions/SelectedLocation/ISelectedLocation';
import { Typography } from '@/shared/components/atoms';

import Close from '~/images/shared/Close.svg';

const SelectedLocation: React.FC<ISelectedLocationProps> = ({
  children,
  onClick,
}) => {
  return (
    <div
      className='flex items-center gap-x-12 rounded-lg bg-primary-12 p-2'
      onClick={onClick}
    >
      <Typography weight='semiBold' className='whitespace-nowrap'>
        {children}
      </Typography>
      <button className='p-2'>
        <Close className='h-12 w-12' />
      </button>
    </div>
  );
};

export default SelectedLocation;
